import { render, staticRenderFns } from "./PartnersPendingStatus.html?vue&type=template&id=26d71ae2&scoped=true&external"
import script from "./PartnersPendingStatus.js?vue&type=script&lang=js&external"
export * from "./PartnersPendingStatus.js?vue&type=script&lang=js&external"
import style0 from "./PartnersPendingStatus.scss?vue&type=style&index=0&id=26d71ae2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d71ae2",
  null
  
)

export default component.exports